

import { motion } from "motion/react";
import { Cpu, Zap, Target } from "lucide-react";

export const SolutionPillars = () => {
  const pillars = [
    {
      title: "Technology That Scales",
      desc: "AI-driven workflows, structured screening, and standardized evaluation — built to process candidates efficiently and at scale.",
      icon: <Cpu className="w-8 h-8" />,
      delay: 0.1
    },
    {
      title: "Execution That Delivers",
      desc: "Active sourcing, continuous follow-ups, and full ownership of your roles — we don’t just enable hiring, we drive it to closure.",
      icon: <Zap className="w-8 h-8" />,
      delay: 0.2
    },
    {
      title: "Outcome-Based Pricing",
      desc: "Pay only when you hire. Our model ensures our success is directly tied to yours.",
      icon: <Target className="w-8 h-8" />,
      delay: 0.3
    }
  ];

  return (
    <section id="solutions" className="py-32 bg-white relative overflow-hidden">
      <div className="blob w-[500px] h-[500px] bg-brand-accent/5 top-[20%] left-[-10%]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-6xl font-display font-bold tracking-tight mb-6">A New Model for Hiring</h2>
            <p className="text-xl text-brand-muted max-w-2xl mx-auto font-medium leading-relaxed italic opacity-80 uppercase tracking-tight">
              QuantumHire combines technology and execution to deliver real hiring outcomes — not just tools or services.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, i) => (
            <motion.div 
              key={i} 
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: pillar.delay, duration: 0.6 }}
              whileHover={{ y: -10 }}
              className="group p-10 bg-brand-secondary rounded-[3rem] border border-gray-100 hover:border-brand-accent/30 hover:shadow-2xl transition-all duration-500 flex flex-col items-center text-center space-y-8"
            >
              <div className="w-20 h-20 rounded-3xl bg-white text-brand-accent flex items-center justify-center shadow-xl shadow-brand-accent/5 group-hover:bg-brand-accent group-hover:text-brand-primary transition-all duration-500 transform group-hover:rotate-6">
                {pillar.icon}
              </div>
              
              <div className="space-y-4">
                <h3 className="text-2xl font-display font-bold tracking-tight text-brand-primary group-hover:text-brand-accent transition-colors">
                  {pillar.title}
                </h3>
                <p className="text-lg text-brand-muted leading-relaxed font-medium">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
